module.exports = __webpack_public_path__ + "static/media/Paques.25f7813e.png";